/* Common Imports */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Data Imports */
import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  illustrationSizer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
}));

const LocationMap = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div>
        <img
          src="/images/illustrations/classes/location_class.webp"
          alt={AppConfig.imageAltText}
          //   width={1152}
          //   height={446}
          loading="lazy"
          referrerPolicy="no-referrer"
          //   longdesc="https://snapanalytx.com"
          className={classes.illustrationSizer}
        />
      </div>
    </React.Fragment>
  );
};

export default LocationMap;
